import React, { useState, useEffect } from 'react'
import { convertToCurrency } from '@utils/utils.js'

let url

const ProductSchema = ({
    mainProduct,
    productTitle,
    productDescription,
    sku,
    mainImage,
    currentPrice,
    product,
    matchingVariants,
    variantIdOnLoad,
}) => {
    let now = new Date()
    let current = new Date(now.getFullYear(), now.getMonth() + 1, 1)

    let priceType = 'product'

    const invalidProductTypes = [
        'Gift Cards',
        'Gift Card',
        'Specialty SKU',
        'Embroidery Option',
        'Embroidery',
        'Virtual Classes',
        'Classes + Events',

        'Classes',
    ]

    let is10Off = false
    let is20Off = false
    let is25Off = false
    let is30Off = false
    let is40Off = false
    let is50Off = false
    let is60Off = false
    let is70Off = false
    let isDoorbuster = false

    const tags = product?.tags
    const vendor = product?.vendor || 'Monica + Andy'
    const productType = product?.product_type

    // console.log('productType', productType)

    const isInvalidProductType = invalidProductTypes.includes(productType)

    // console.log('isInvalidProductType', isInvalidProductType)

    const variants = product?.variants

    //

    let firstVariantWithInventory

    if (vendor === 'Monica + Andy' && !isInvalidProductType) {
        firstVariantWithInventory = variants?.find(
            (variant) => variant?.inventory_quantity > 0
        )
        if (
            (tags && tags?.includes('fallhalloween2024')) ||
            tags?.includes('halloween')
        ) {
            is50Off = true
        }
        if (tags?.includes('doorbuster2024')) {
            isDoorbuster = true
        }
    } else if (
        matchingVariants &&
        matchingVariants.length > 0 &&
        !isInvalidProductType
    ) {
        firstVariantWithInventory = matchingVariants
            ? matchingVariants[0]
            : variants[0]
    } else if (variantIdOnLoad) {
        firstVariantWithInventory = variants?.find(
            (variant) => variant?.id?.toString() === variantIdOnLoad?.toString()
        )
    } else if (!isInvalidProductType) {
        firstVariantWithInventory = variants[0]
    }

    //

    const [price, setPrice] = useState({})

    const [discountPercent, setDiscountPercent] = useState(0)

    useEffect(() => {
        const roundIfNeeded = (price) => {
            // console.log('price in roundIfNeeded', price)
            const decimal = price % 1
            const firstDecimal = Math.floor((decimal * 10) % 10)
            const secondDecimal = Math.floor((decimal * 100) % 10)
            const thirdDecimal = Math.floor((decimal * 1000) % 10)

            return firstDecimal === 9 ||
                secondDecimal === 9 ||
                thirdDecimal >= 5
                ? Math.ceil(price)
                : price
        }

        // setPrice({
        //     price: convertToCurrency(firstVariantWithInventory?.price),
        //     compareAtPrice: product?.title.includes('SALE')
        //         ? convertToCurrency(product?.compare_at_price_max)
        //         : null,
        //     discountPrice: null,
        // })

        if (product?.title.includes('Zip-Up Sweater')) {
            console.log(
                'firstVariantWithInventory',
                firstVariantWithInventory?.price,
                firstVariantWithInventory?.price * 0.5,
                convertToCurrency(firstVariantWithInventory?.price * 0.5)
            )
        }

        if (vendor === 'Monica + Andy' && !isInvalidProductType) {
            // console.log('product here', product)
            // if (
            //     tags?.includes('halloween') ||
            //     tags?.includes('fallhalloween2024')
            // ) {
            //     setPrice({
            //         price: convertToCurrency(product?.price_max),
            //         compareAtPrice: product?.title.includes('SALE')
            //             ? convertToCurrency(product?.compare_at_price_max)
            //             : null,
            //         discountPrice: product?.title.includes('SALE')
            //             ? roundIfNeeded(
            //                   convertToCurrency(product?.price_max) * 0.5 + 0.01
            //               )
            //             : roundIfNeeded(
            //                   convertToCurrency(product?.price_max) * 0.5
            //               ),
            //     })

            //     let discount = Math.round(
            //         100 -
            //             (convertToCurrency(
            //                 firstVariantWithInventory?.price * 0.5
            //             ) /
            //                 convertToCurrency(product?.compare_at_price_max)) *
            //                 100
            //     )

            //     if (product?.title.includes('SALE')) {
            //         setDiscountPercent(discount)
            //     } else {
            //         setDiscountPercent(50)
            //     }
            // } else
            if (
                tags?.includes('wintertoystory2024') ||
                tags?.includes('winterdisneyprincess2024')
            ) {
                setPrice({
                    price: convertToCurrency(product?.price_max),
                    compareAtPrice: convertToCurrency(
                        product?.compare_at_price_max
                    ),

                    discountPrice: roundIfNeeded(
                        convertToCurrency(firstVariantWithInventory?.price) *
                            0.8
                    ),
                })

                setDiscountPercent(20)
            } else if (
                tags?.includes('disneyfrozen2023') ||
                tags?.includes('disneycars2024') ||
                tags?.includes('barbie2024') ||
                tags?.includes('holiday60off') ||
                tags?.includes('falllionking2024')
            ) {
                if (product?.title.includes('3-Piece Baby Set')) {
                    console.log(
                        'price here above with tags',
                        product?.title,
                        product?.price_max,
                        product?.compare_at_price_max
                    )
                }
                setPrice({
                    price: convertToCurrency(product?.price_max),
                    compareAtPrice: product?.title.includes('SALE')
                        ? convertToCurrency(product?.compare_at_price_max)
                        : null,
                    discountPrice: convertToCurrency(product?.price_max) * 0.4,
                })

                const compareAtPrice = convertToCurrency(
                    product?.compare_at_price_max
                )
                const discountedPrice =
                    convertToCurrency(firstVariantWithInventory?.price) * 0.4

                const amountOff = compareAtPrice - discountedPrice

                const discount = roundIfNeeded(
                    (amountOff / compareAtPrice) * 100
                )

                if (product?.title.includes('SALE')) {
                    // discount = Math.round(discount)
                    // console.log('discount', discount)
                    setDiscountPercent(discount)
                } else {
                    setDiscountPercent(60)
                }
            } else if (!isInvalidProductType) {
                if (product?.title.includes('3-Piece Baby Set')) {
                    // console.log('in this price')
                }
                setPrice({
                    price: convertToCurrency(product?.price_max),
                    compareAtPrice: product?.title.includes('SALE')
                        ? convertToCurrency(product?.compare_at_price_max)
                        : null,
                    discountPrice: product?.title.includes('SALE')
                        ? roundIfNeeded(
                              convertToCurrency(
                                  firstVariantWithInventory?.price
                              ) *
                                  0.6 +
                                  0.01
                          )
                        : roundIfNeeded(
                              convertToCurrency(
                                  firstVariantWithInventory?.price
                              ) * 0.6
                          ),
                })

                // setDiscountPercent(0)

                // let discount = Math.round(
                //     100 -
                //         (convertToCurrency(firstVariantWithInventory?.price) /
                //             convertToCurrency(product?.compare_at_price_max)) *
                //             100
                // )

                // let discount = Math.round(
                //     100 -
                //         (convertToCurrency(discountedPrice) /
                //             convertToCurrency()) *
                //             100
                // )

                // console.log('discount', discount, firstVariantWithInventory?.price)

                const compareAtPrice = convertToCurrency(
                    product?.compare_at_price_max
                )
                const discountedPrice =
                    convertToCurrency(firstVariantWithInventory?.price) * 0.6

                const amountOff = compareAtPrice - discountedPrice

                const discount = Math.round((amountOff / compareAtPrice) * 100)

                if (product?.title.includes('SALE')) {
                    // discount = Math.round(discount)
                    // console.log('discount', discount)
                    setDiscountPercent(discount)
                } else {
                    setDiscountPercent(40)
                }
            }
        } else if (!isInvalidProductType) {
            if (product?.title.includes('3-Piece Baby Set')) {
                // console.log('price here below', product?.title)
            }
            setPrice({
                price: convertToCurrency(
                    firstVariantWithInventory?.price || product?.price_max
                ),
                compareAtPrice: product?.compare_at_price_max
                    ? convertToCurrency(product?.compare_at_price_max)
                    : null,
                discountPrice: null,
            })
            const discount = Math.round(
                100 -
                    (convertToCurrency(firstVariantWithInventory?.price) /
                        convertToCurrency(product?.compare_at_price_max)) *
                        100
            )
            if (priceType === 'product') {
                // console.log('discount below', discount)
            }

            if (discount > 0 && discount < 100) {
                setDiscountPercent(discount)
            }

            // setDiscountPercent(0)
        }

        // if (vendor === 'Monica + Andy') {
        //     if (product?.title.includes('SALE')) {
        //         setPrice({
        //             price: convertToCurrency(product?.price_max),
        //             compareAtPrice: product?.title.includes('SALE')
        //                 ? convertToCurrency(product?.compare_at_price_max)
        //                 : null,
        //             discountPrice: convertToCurrency(
        //                 product?.price_max * 0.75 + 0.01
        //             ),
        //         })
        //     } else {
        //         setPrice({
        //             price: convertToCurrency(product?.price_max),
        //             compareAtPrice: product?.title.includes('SALE')
        //                 ? convertToCurrency(product?.compare_at_price_max)
        //                 : null,
        //             discountPrice: null,
        //         })
        //     }
        // } else {
        //     setPrice({
        //         price: convertToCurrency(firstVariantWithInventory?.price),
        //         compareAtPrice: product?.title.includes('SALE')
        //             ? convertToCurrency(product?.compare_at_price_max)
        //             : null,
        //         discountPrice: null,
        //     })
        // }

        // setPrice({
        //     price: convertToCurrency(product?.price_max),
        //     compareAtPrice: product?.title.includes('SALE')
        //         ? convertToCurrency(product?.compare_at_price_max)
        //         : null,
        //     discountPrice: convertToCurrency(product?.price_max * 0.8 + 0.01),
        // })
        // if (vendor === 'Monica + Andy') {
        //     if (product?.title.includes('SALE')) {
        //         setPrice({
        //             price: convertToCurrency(product?.price_max),
        //             compareAtPrice: product?.title.includes('SALE')
        //                 ? convertToCurrency(product?.compare_at_price_max)
        //                 : null,
        //             discountPrice: convertToCurrency(
        //                 product?.price_max * 0.6 + 0.01
        //             ),
        //         })
        //     } else {
        //         setPrice({
        //             price: convertToCurrency(product?.price_max),
        //             compareAtPrice: product?.title.includes('SALE')
        //                 ? convertToCurrency(product?.compare_at_price_max)
        //                 : null,
        //             discountPrice: convertToCurrency(product?.price_max * 0.6),
        //         })
        //     }
        // } else {
        //     setPrice({
        //         price: convertToCurrency(firstVariantWithInventory?.price),
        //         compareAtPrice: product?.title.includes('SALE')
        //             ? convertToCurrency(product?.compare_at_price_max)
        //             : null,
        //         discountPrice: null,
        //     })
        // }
        // setPrice({
        //     price: convertToCurrency(firstVariantWithInventory?.price),
        //     compareAtPrice: product?.title.includes('SALE')
        //         ? convertToCurrency(product?.compare_at_price_max)
        //         : null,
        //     discountPrice: null,
        // })

        //     // if (product?.title.includes('SALE')) {
        //     //     is20Off = true;
        //     //     setPrice({
        //     //         price: convertToCurrency(product?.price_max),
        //     //         compareAtPrice: product?.title.includes('SALE')
        //     //             ? convertToCurrency(product?.compare_at_price_max)
        //     //             : null,
        //     //         discountPrice: convertToCurrency(
        //     //             product?.price_max * 0.8 + 0.01
        //     //         ),
        //     //     });
        //     // } else {
        //     //     is20Off = false;
        //     //     setPrice({
        //     //         price: convertToCurrency(firstVariantWithInventory?.price),
        //     //         compareAtPrice: product?.title.includes('SALE')
        //     //             ? convertToCurrency(product?.compare_at_price_max)
        //     //             : null,
        //     //         discountPrice: null,
        //     //     });
        //     // }
        // } else {
        //     // is20Off = false
        //     setPrice({
        //         price:
        //             convertToCurrency(firstVariantWithInventory?.price) ||
        //             product?.price_max,
        //         compareAtPrice: product?.title.includes('SALE')
        //             ? convertToCurrency(product?.compare_at_price_max)
        //             : null,
        //         discountPrice: null,
        //     })
        // }
    }, [
        product,
        firstVariantWithInventory,
        vendor,
        matchingVariants,
        variantIdOnLoad,
    ])

    useEffect(() => {
        url = window.location.href
    }, [])

    return (
        <div itemScope itemType='http://schema.org/Product'>
            <meta
                itemProp='name'
                content={productTitle?.split('_')[0].replace('[hidden]', '')}
            />
            <meta
                itemProp='description'
                content={productDescription ? productDescription : ''}
            />
            <meta itemProp='sku' content={sku} />
            <meta itemProp='url' content={url} />
            <meta itemProp='image' content={mainImage.src} />
            <meta
                itemProp='brand'
                content={
                    mainProduct[0]?.vendor
                        ? mainProduct[0]?.vendor
                        : 'Monica + Andy'
                }
            />
            <meta itemProp='mpn' content={sku} />
            <div itemProp='offers' itemScope itemType='http://schema.org/Offer'>
                <meta itemProp='priceCurrency' content='USD' />
                <meta
                    itemProp='price'
                    content={
                        convertToCurrency(price.discountPrice)
                            ? convertToCurrency(price.discountPrice)
                            : convertToCurrency(price.compareAtPrice)
                            ? convertToCurrency(price.compareAtPrice)
                            : convertToCurrency(price.price)
                    }
                />
                <meta itemProp='priceValidUntil' content={current} />
                <meta
                    itemProp='availability'
                    content='http://schema.org/InStock'
                />
                <meta
                    itemProp='itemCondition'
                    itemType='http://schema.org/OfferItemCondition'
                    content='http://schema.org/NewCondition'
                />
                <meta itemProp='seller' content='Monica + Andy' />
                <meta itemProp='url' content={url} />
            </div>
        </div>
    )
}

export default ProductSchema
